// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfSecond as fn } from "../endOfSecond.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfSecondWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default endOfSecondWithOptions;
